module.exports = __webpack_public_path__ + "img/circle_two.e4238904.png";